// Load Bootstrap JS
import bootstrap from 'bootstrap'

// Load Styles
import '../scss/main.scss';
import initSlider from "./modules/slider";
import initMenu from "./modules/init_menu";
import initFixedMenu from "./modules/init_fixed_menu";
import setBlockTitleHeight from "./modules/set_block_title_height";
import initAnnouncementBar from "./modules/init_annoucement_bar";
// Demo of using .env variables
// console.log(`Google Maps API Key: ${process.env.GOOGLE_MAPS_API_KEY}`);
import "@lottiefiles/lottie-player";
import initFileInputButton from "./modules/init_file_input_button";
import initCF7SubmitModal from "./modules/init_cf7_submit_modal";
import initApplicationSelect from "./modules/init_application_select";
import initNewsList from "./modules/init_news_list";
import initEmailAddress from "./modules/init_email_address";
import initLightbox from "./modules/init_lightbox";
document.addEventListener("DOMContentLoaded", () => {
    initSlider();
    initMenu();
    initFixedMenu();
    initAnnouncementBar();
    setBlockTitleHeight('.ks-news');
    setBlockTitleHeight('.ks-benefit-list');

    initFileInputButton();
    initCF7SubmitModal();
    initApplicationSelect();

    initNewsList(12);

    initLightbox();

    initEmailAddress('.ks-email');
});
